<template>
    <div class="find-body" @click="onClickOutside">

        <div class="find-top">
            <div class="back" @click="back">
                <i class="iconfont icon-left-01"></i>
            </div>
            <div class="find-top-name">
                <div class="car-number">输入车牌号</div>
                <div class="my-number" @click="myPlateNumber"  v-show="user">
                    <button>我的车牌</button>
                </div>
            </div>
        </div>

        <div class="find-con">
            <div class="find-data">
                <div class="find-input" @click.stop="actIpt" :class="{'ipt-active':iptActive}">

                    <div class="ipt-province" @click="selProvince">
                        <span>{{province}}</span>
                        <i class="iconfont icon-down-01"></i>
                    </div>

                    <div class="inp-car-number">
                        <input @click="stopOutside" onfocus="this.blur()"  v-model="carName" type="text" readonly/>
                    </div>
                </div>
                <div class="find-font">
                    <div class="circle">
                        <i class="iconfont icon-quan" @click.stop="addCar"></i>
                    </div>
                    <p class="font-description">加入我的车牌，享一键自动填入，且永久保存</p>
                    <transition name="fade">
                        <span class="recom" v-if="recom">推荐</span> <!--<i class="iconfont icon-sanjiaoxing"></i>-->
                    </transition>
                </div>
                <div class="find-btn" :class="{'btn-active':btnActive}" @click.stop="findCar">查找爱车</div>
            </div>
            <div class="find-history">
                <p>最近查找</p>
                <ul class="history-list">
                    <li v-if="index < 8" v-for="(item,index) in historyFind"  :key="item.id" @click.stop="writeInput(item.name)">{{item.name}}</li>
                </ul>
            </div>
        </div>
        <!--由智石科技提供技术支持-->
        <div class="copyright">{{JSON.parse($mapStore.plugInfo.plugInfo.plugInSettings.apply).copyright}}</div>
        <!--省份键盘-->
        <div id="prvKey" class="province" :class="{'key-show':keyboard}" v-click-outside="onClickOutside">

            <div class="close-province" @click="closePro">
                <i class="iconfont icon-cha"></i>
            </div>

            <div class="prov-row" v-for="(item,index) in carTxt" :key="index">
               <p @click.stop="selectCar" v-for="(province,i) in item.name" :key="i">{{province}}</p>
            </div>
        </div>

        <!--字母键盘-->
        <div class="letters" :class="{'letters-show':letterShow}" v-click-outside="onClickOutside">
            <div class="close-province" @click="closeLetter">
                <i class="iconfont icon-cha"></i>
            </div>
            <p class="letter-list" @click="letterClick" v-for="(letter,i) in letters" :key="i">{{letter}}</p>
            <p class="action" @click="clearAll">清空</p>
            <p class="action" @click="letterBack">回删</p>
        </div>

        <!---字母 数字键盘-->
        <div class="letters" :class="{'end-letter':endKeyBoard}" v-click-outside="onClickOutside">
            <div class="close-province" @click="closeKey">
                <i class="iconfont icon-cha"></i>
            </div>
            <p class="letter-list" @click="keyClick" v-for="(letter,i) in keyboards" :key="i">{{letter}}</p>
            <p class="actions" @click="clearAll">清空</p>
            <p class="actions" @click="backDelete">回删</p>
        </div>

        <div class="my-car search-car" :class="{'search-end':searCar}">
            <!--查找爱车-->
            <SearchResult v-show="plateNumber" :carData="carData" @childClose="closeVal" @childResult="editCarNum"></SearchResult>
            <!--我的车牌-->
            <Mycar v-show="!plateNumber" @save="myCarSave" @childClose="closeVal" @resulte="writeInput" :myCarData="myCarData" :historyData="historyFind" :hh="carHeight"></Mycar>
        </div>

        <!--遮罩-->
        <div class="shade" v-show="shade" @click="closeMask"></div>

        <!--查找无结果-->
        <div class="search-null" v-show="searchDialog">
            <span>{{dialogVal}}</span>
        </div>
  </div>
</template>

<script>
import Mycar from './modules/mycar/MyCar'
import SearchResult from './modules/searchresult/SearchResult'
import {directive as clickOutside} from 'v-click-outside-x';
import {getCarData,addCarData,findCarData} from '@/config/prepare.js'

//模拟爱车信息
// let _data = {
//
//     carN:'渝A123456',
//     parkN:'B457',
//     parkT:'1时15分',
//     enterT:'2019/04/15 09:14:14',
//     imgUrl:'./images/car.png',
//     address:'美源美源',
//     poi:{
//         CATEGORY_ID:"110200",
//         CATEGORY_NAME:"中餐厅",
//         FLOOR_ID:"00270007F01",
//         FLOOR_NAME:"F1",
//         FLOOR_NUMBER:1,
//         LABEL_X:12738315.225449998,
//         LABEL_Y:3582471.7546443306,
//         NAME:"C1到达区",
//         POI_ID:"F1JC87"
//     }
// }


export default {
    name: 'SearchCar',
    directives: { clickOutside },
    data () {
        return {
            carName:'',//输入的值
            carID:'',   //云存入车牌ID
            btnActive:false,//按钮是否激活
            province: this.$mapStore.plugInfo.plugInfo.plugInSettings.findCar &&  this.$mapStore.plugInfo.plugInfo.plugInSettings.findCar.defaultCarCity ? this.$mapStore.plugInfo.plugInfo.plugInSettings.findCar.defaultCarCity : '渝',
            iptActive:false,//输入框border
            searCar:false,
            keyboard:false,//省
            letterShow:false,//首字母
            endKeyBoard:false,//混合
            user:true,//我的车牌
            recom:false,//推荐
            carHeight: '',//我的车牌高度
            addIcon:false,//标识
            shade:false,//遮罩
            plateNumber:true,//我的车牌 查找
            searchDialog:false,
            dialogVal:'查找无结果，请重新修改试试',
            //省份
            carTxt: [
                { name: ['湘', '京', '津', '冀', '晋', '蒙'] },
                { name: ['辽', '吉', '黑', '沪', '苏', '浙'] },
                { name: ['皖', '闽', '赣', '鲁', '豫', '鄂'] },
                { name: ['粤', '桂', '琼', '川', '贵','云'] },
                { name: ['渝', '藏', '陇', '甘', '青','宁'] },
                { name: ['新', '港', '澳', '台'] }],
            //首字母
            letters:['A','B','C','D','E','F','G','H','J','K','L','M','N','P','Q','R','S','T','U','V','W','X','Y','Z'],
            //字母数字键盘
            keyboards:[1,2,3,4,5,6,7,8,9,0,'A','B','C','D','E','F','G','H','J','K','L','M','N','P','Q','R','S','T','U','V','W','X','Y','Z','警','学','使'],

            //最近查找
            historyFind:[
                // { id: 1,name:'渝A12345'},
                // { id: 2,name:'渝A12346'},
                // { id: 3,name:'渝A12347'},
                // { id: 4,name:'渝A12348'},
            ],

            //我的保存车
            myCarData:[
                // {id:1,provice:'渝D',number:'257AA'},
                // {id:2,provice:'川D',number:'1257BB'},
                // {id:3,provice:'浙A',number:'76666'},
                // {id:4,provice:'京B',number:'88888'},
            ],

            carData:'',

            isOne:false   //是否是初次
        }
    },

    //更动数据
    activated(){
        this.initData();
    },

    watch:{
        carName(val){//监视输入框变化
            let iptLength = val.length
            if(iptLength >= 6){
                this.btnActive = true
            }
            else{
                this.btnActive = false
            }
            if(iptLength > 7){
                let maxLength = val.substr(0,7);
                this.carName = maxLength
            }
        }

    },

    methods: {


        back(){

            if(this.$BRT.lastRoute){
                this.$router.replace(this.$BRT.lastRoute)
            }else{
                this.$router.replace('/map')
            }
        },

        //防止干扰
        stopOutside(){this.focus();},
        //初始化数据
        initData($status){

            //6s隐藏图标
            //每次打开提示三次
            if(!$status && !this.recom && this.isOne < 3){
                this.recom = true;
                this.isOne ++ ;
                setTimeout(()=>{this.recom = false},6000)
            }

            //退出账号处理
            if(!$status && !this.$mapStore.plugInfo.phone){  //清空云车牌
                this.myCarData = [];
                this.carName = '';
            }

            //获取车牌数据
            getCarData(this,(res)=>{

                let $data = [];

                if(res.data.code == 0){

                    if(res.data.result.length > 0){

                        this.carID = res.data.result[0].id;

                        $data = this.carDataFormat(JSON.parse(res.data.result[0].plateArray));
                    }
                }

                this.myCarData = $data;

                if(!$status){//初始操作

                    //自动填入数据
                    if(this.myCarData.length > 0){

                        let $carN = this.myCarData[0].provice + this.myCarData[0].number;
                        this.writeInput($carN);
                        this.$message.info('已自动一键填入我的车牌');

                    }else{
                        this.carName = '';
                        this.myCarData = [];
                    }
                }

            })

            //拿到历史纪录
            let $carStorageNAME = 'carHistory'+this.$mapStore.plugInfo.buildingId;
            this.historyFind = JSON.parse(window.localStorage.getItem($carStorageNAME)) ? JSON.parse(window.localStorage.getItem($carStorageNAME)) :[];
        },

        onClickOutside(){

            this.iptActive = false;

            if(this.keyboard){

                this.keyboard = false;

            }else if(this.letterShow){

                this.letterShow = false;
            }else{

                this.endKeyBoard = false;
            }

        },
        //点击打开省份键盘
        selProvince(){
            this.letterShow = false;//字母键盘关闭
            this.endKeyBoard = false;//

            setTimeout(() => {
                // console.log('触发...')
                this.keyboard = true;
            },0);
        },
        //选择车牌省份
        selectCar(e){

            let elText = e.currentTarget.innerText;
            this.province = elText;
            this.keyboard = false;

            setTimeout(() => {
                this.letterShow = true;
            }, 10);

        },

        //关闭省份键盘
        closePro(){
            this.keyboard = false
        },
        //首字母键盘
        focus(){

            // event.stopPropagation();
            //
            // this.iptActive = true;//边框变蓝
            this.keyboard = false;//省份键盘关闭

            setTimeout(() => {
                if(this.carName.length>2){
                    this.endKeyBoard = true;
                }else{
                    this.letterShow = true;
                }
            }, 50);
        },
        //关闭字母键盘
        closeLetter(){
            this.letterShow = false;
        },
        //点击字母键盘
        letterClick(e){
            event.stopPropagation();
            let letterText = e.currentTarget.innerText;
            this.carName = letterText;

            setTimeout(() => {
                this.letterShow = false;//关闭字母键盘
                this.endKeyBoard = true;//打开混合键盘
            }, 10);
        },
        //混合键盘点击
        keyClick(e){
            event.stopPropagation();
            let keyText = e.currentTarget.innerText;
            this.carName += keyText;
        },
        //混合键盘关闭
        closeKey(){

            this.endKeyBoard = false;
        },
        //回删
        backDelete(){
            event.stopPropagation();
            this.carName = this.carName.substr(0,this.carName.length-1);
            if(this.carName.length == 1){
                this.endKeyBoard = false;
                this.letterShow = true;
            }
        },
        //首字母键盘回删
        letterBack(){
            event.stopPropagation();
            this.carName = '';
            this.letterShow = false;
            this.keyboard = true;
        },
        //键盘清空
        clearAll(){
            event.stopPropagation();
            this.carName = '';
            this.endKeyBoard = false;
            this.letterShow = true;

        },

        //加入我的车牌
        addCar($event){

            if(!this.$mapStore.plugInfo.phone){
                this.$message.info('请先登录');
                this.bus.$emit('LoginCallback',{status:1});
                return;
            }

            if(this.addIcon == false){
                $event.currentTarget.className = 'iconfont icon-yuanquangou green';
                this.addIcon = true;
                this.dialogVal = '已自动一键填入我的车牌';
                this.searchDialog = true;
                setTimeout(() => {
                    this.searchDialog = false
                }, 3000);
            }
            else{
                $event.currentTarget.className = 'iconfont icon-quan';
                this.addIcon = false;
            }

        },

        carDataFormat(carData){

            let $data = [];

            for(let i=0;i<carData.length;i++){

                $data.push({
                    id:carData[i].id,
                    provice:carData[i].carNo.slice(0,2),
                    number:carData[i].carNo.slice(2,carData[i].carNo.length)
                })

            }

            return $data;
        },

        carDataFormatRever(carData){

            let $dataCarUp =[];

            for(let i=0;i<carData.length;i++){
                $dataCarUp.push({
                    id:carData[i].id,
                    carNo:''+carData[i].provice + carData[i].number
                })
            }

            return $dataCarUp;
        },
        //查找爱车
        findCar(){

            if(this.btnActive == true){

                let $carN =this.province + this.carName;
                findCarData(this,{carID:$carN},(res)=>{
                    // console.log('查车数据',res);
                    let result = res.data.result;
                    if(result){

                        //组装数据
                        let $data = {
                            carN:$carN,
                            parkN:'B457',
                            parkT:'1时15分',
                            enterT:'2019/04/15 09:14:14',
                            imgUrl:result.imgUrl,
                            address:this.$mapStore.plugInfo.plugInfo.name,
                            poi:result
                        }

                        this.carData = $data;

                        //防止ID重复
                        let hID = this.historyFind.length > 0 ?(this.historyFind.sort((v1,v2)=>{
                                return v2.id - v1.id;
                            })[0].id + 1) : 0,

                            mID = this.myCarData.length > 0 ? (this.myCarData.sort((v1,v2)=>{
                                return v2.id - v1.id;
                            })[0].id + 1) : 0;

                        /***********追加历史记录********************/

                            //防止重复
                            // let $carN =this.province + this.carName;

                        let $hArr = this.historyFind.filter((item,index,self)=>{

                                if(item.name == $carN){//交换位置

                                    let $temp = item;

                                    this.historyFind.splice(index,1);   //删除该元素

                                    this.historyFind.unshift($temp);
                                }

                                return item.name == $carN;
                            })

                        //追加元素
                        if($hArr.length == 0){this.historyFind.unshift({id:hID,name:$carN});}

                        /**************追加保护车辆****************/
                        if(this.addIcon){

                            let $mArr = this.myCarData.filter((item,index,self)=>{

                                let name = '' + item.provice + item.number;

                                if(name == $carN){//交换位置

                                    let $temp = item;

                                    this.myCarData.splice(index,1);   //删除该元素

                                    this.myCarData.unshift($temp);
                                }

                                return name == $carN;
                            })


                            //追加元素
                            if($mArr.length == 0){

                                this.myCarData.unshift({
                                    id:mID,
                                    provice:$carN.slice(0,2),
                                    number:$carN.slice(2,$carN.length)
                                });

                            }

                        }

                        if(this.addIcon){
                            //修改资源
                            this.myCarSave();

                        }else{//保存历史记录

                            this.myCarSave({status:1});
                        }


                        this.shade = true;
                        this.plateNumber = true;
                        this.endKeyBoard = false;//键盘关闭
                        this.searCar = true;

                    }else{

                        this.endKeyBoard = false;//键盘关闭
                        this.searchDialog = true;

                        setTimeout(() => {
                            this.searchDialog = false
                        }, 300);

                    }


                })

            }

        },

        //我的车牌
        myPlateNumber(){

            if(!this.$mapStore.plugInfo.phone){
                this.$message.info('请先登录');
                this.bus.$emit('LoginCallback',{status:1});
                return;
            }

            //防止未保存再次进入
            this.initData({status:1});

            let height = window.innerHeight * 0.8;
            let intNumber = Math.round(height)
            this.carHeight = intNumber.toString();
            this.shade = true;
            this.plateNumber = false;
            this.searCar = true;
        },

        actIpt(){
            this.iptActive = true;//框蓝色
        },

        //关闭寻车-我的车牌
        closeVal(val){

            this.searCar = val;
            this.shade = false;
            this.initData({status:1});
        },

        //编辑状态
        editCarNum(){
            this.shade = false;
            this.searCar = false;
            this.endKeyBoard = true;
        },

        //关闭我的车牌
        plateVal(val){
            // console.log('触发了关闭车牌。。。')
            this.searCar = val;
            this.shade = false;
        },

        //我的车牌修改保存
        myCarSave(res){

            //保存历史记录
            let $carStorageNAME = 'carHistory'+this.$mapStore.plugInfo.buildingId;
            window.localStorage.setItem($carStorageNAME,JSON.stringify(this.historyFind));

            if( res && res.status == 1 )return false;//只保存历史记录
            //转换数据
            let $dataCarUp = this.carDataFormatRever(JSON.parse(JSON.stringify(this.myCarData)));

            //上传云服务车牌
            addCarData(this,$dataCarUp,this.carID,(res)=>{

                getCarData(this,($res)=>{

                    this.myCarData = this.carDataFormat(JSON.parse($res.data.result[0].plateArray));

                })
            })
        },

        //写入input
        writeInput(carN){

            this.province = carN.slice(0,1);
            this.carName = carN.slice(1,carN.length);

            // console.log('this.province',this.province,'this.carName',this.carName);
        },

        //关闭遮罩层
        closeMask(){
            event.stopPropagation();
            this.searCar=false;
            this.shade=false;
            this.bus.$emit('myCarClose');
        }
    },


    mounted(){

        // if(this.user == false){
        //    setTimeout(()=>{this.recom = false},300)
        // }

        //自动填入数据
        // if(this.$mapStore.plugInfo.phone){
        //
        //     this.initData(()=>{
        //         // provice:'渝D',number:'257AA'
        //         // console.log(this.myCarData);
        //         if(this.myCarData.length > 0){
        //
        //             let $carN = this.myCarData[0].provice + this.myCarData[0].number;
        //             this.writeInput($carN);
        //
        //         }
        //
        //     })
        //
        // }

    },
    components:{
        Mycar,
        SearchResult
    }

}
</script>

<style lang='less' scoped>
    @import "../../styles/cssBlock";
    @import "./SearchCar";
</style>
